import React from "react";

export function AccountsLedger() {
  return (
    <div>
      <h3>
        Avvakta med denna och kolla med Micke hur denna vy ska se ut.. Ska det
        finnas en länk i sidonavigeringen som heter konto där vyn
        består av två knappar och att olika tabeller visar beroende på vilken
        knapp som är aktiv (likt detta exempel) aktiv (likt detta exempel) I så
        fall behöver vi endpoint för att hämta alla endcustomeraccounts,
        endcustomer printed invoices, endcustomer payed invoices BASERAT på
        endcustomerID.
        <br></br> ELLER ska bankfiler och konto flyttas ut till sidonavigering
        ELLER ska klientreskontra vara en separat sida vara en helt separat sida
        med egen sidonavigering.
      </h3>
      <button>Konton</button>
      <button>BankFiler</button>

      <h2>
        TABELL SOM VISAR ANTINGEN KONTO ELLER BAKFILER beroende på vilken knapp
        som är aktiv
      </h2>
    </div>
  );
}
